export default __webpack_public_path__ + "static/media/blueDownloadIcon.8156ff74.svg";